let baseDomain = `${location.protocol}//${location.host}`
let qxyRes = 'https://tctext_res.qxueyou.com/'
let serverContext = '/intelligence/stu'
let htmlContext = '/intelligence/web/h5/#/'

let pathnames = location.pathname.split('/web/h5/')
if (pathnames.length > 1) {
  serverContext = `${pathnames[0]}/stu`
  htmlContext = `${pathnames[0]}/web/h5/#`
}

export default {
  domain: baseDomain,
  qxyRes: qxyRes,
  baseUrl: serverContext,
  htmlRoot: baseDomain + htmlContext,
  serverRoot: baseDomain + serverContext,
  upload: `/base/file/upload`,
  uploadChunkInit: `/base/file/uploadChunk/init`,
  uploadChunk: `${serverContext}/base/file/uploadChunk`,
  wxLogin: 'https://open.weixin.qq.com/connect/oauth2/authorize',
  wxAppId: 'wx14881d8558e731ab',
  wxRedirectUrl: `${baseDomain + htmlContext}login/redirect`
}